// extracted by mini-css-extract-plugin
module.exports = {"detailWrap":"provider-info-screen_detailWrap__9Oys2"};